export const THEME_INDEX = 0;

export const TOKEN_STORAGE_KEY = 'cc-t';
export const ORGANIZATION_STORAGE_KEY = 'org';
export const CURRENCY_STORAGE_KEY = 'currency';
export const COUNTRY_STORAGE_KEY = 'country';

export const GRAPHQL_POLLINTERVAL_SECONDS_START = 10000;
export const GRAPHQL_POLLINTERVAL_SECONDS_MAX = 90000;
